var map = {
	"./Auth/ForgotPassword": 3261,
	"./Auth/ForgotPassword.vue": 3261,
	"./Auth/Login": 6099,
	"./Auth/Login.vue": 6099,
	"./Auth/NewPassword": 8822,
	"./Auth/NewPassword.vue": 8822,
	"./Auth/Register": 8253,
	"./Auth/Register.vue": 8253,
	"./Auth/VerifyMobile": 5763,
	"./Auth/VerifyMobile.vue": 5763,
	"./BmiResult": 2197,
	"./BmiResult.vue": 2197,
	"./Consulting": 2466,
	"./Consulting.vue": 2466,
	"./Diseases": 8557,
	"./Diseases.vue": 8557,
	"./Packages": 1389,
	"./Packages.vue": 1389,
	"./Payment": 2077,
	"./Payment.vue": 2077,
	"./PhysicalInformation": 7223,
	"./PhysicalInformation.vue": 7223,
	"./Redirect": 2532,
	"./Redirect.vue": 2532,
	"./Welcome": 3043,
	"./Welcome.vue": 3043
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8846;